import React from 'react'
function Stats() {
    return ( 
        <>
            <div className="container mt-5 mb-5">
                <div className="row mt-5">
                    <div className="col-7 mt-5">
                        <h1 className=" mt-5">Trust with confidence</h1>
                        <div className="row mt-5">
                            <h2>
                                Customer-first always
                            </h2>
                            <p className="text-muted">
                                That's why 1.3+crore customers trust Zerodha with 35+lakh crore worth of equityinvestments.
                            </p>
                        </div>
                        <div className="row ">
                            <h2>
                                No spam or gimmicks
                            </h2>
                            <p className="text-muted">
                                No gimmicks, spam, "gamification", or annoying push notifications. High quality apps that you use at your pace, the way you like.
                            </p>
                        </div>
                        <div className="row ">
                            <h2>
                                The Zerodha universe
                            </h2>
                            <p className="text-muted">
                                Not just an app, but a whole ecosystem. Our investments in 30+ fintech startups offer you tailored services specific to your needs.
                            </p>
                        </div>
                        <div className="row ">
                            <h2>
                                Do better with money
                            </h2>
                            <p className="text-muted">
                                With initiatives like Nudge and Kill Switch, we don't just facilitate transactions, but actively help you do better with your money.
                            </p>
                        </div>
                    </div>
                    <div className="col-5 mt-5 ">

                        <img className='mt-5' src='media/images/ecosystem.png' alt='Stats Image' style={{ width: "90%",height:"70%" }} />
                        <div className='text-center mt-3'>
                            <a href='#' className='mx-5' style={{textDecoration:"None"}}>Explore our Products <i class="fa-solid fa-arrow-right-long"></i></a>
                            <br className='mt-2'></br>
                            <a href='#' style={{textDecoration:"None"}} >Try Kite demo</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
     );
}

export default Stats;